import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { MaxBrainUtils } from 'app/projects/core/src/lib/utils';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { FeatureSwitchName } from 'app/projects/shared/src/lib/enums/feature-switch.enum';
import { FeatureSwitchPipe } from 'app/projects/shared/src/lib/pipes/feature-switch.pipe';
import NutrientViewer, { Instance } from '@nutrient-sdk/viewer';
import { IMaxBrainEnvironment } from '../../interfaces/environment.interface';

@Component({
    selector: 'app-pdf-web-viewer',
    templateUrl: './pdf-web-viewer.component.html',
    styleUrls: ['./pdf-web-viewer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class PdfWebViewerComponent implements OnInit {
    @Input()
    pdf: string;

    @Input()
    height: string;

    @Input()
    enableHistory = false;

    @Output()
    load = new EventEmitter<Instance>();

    isCustomDomainFeatureEnabled: boolean;

    constructor(@Inject(MAXBRAIN_ENVIRONMENT) private environment: IMaxBrainEnvironment, private _featureSwitchPipe: FeatureSwitchPipe, private _tenantData: TenantDataService) {
        this.isCustomDomainFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.CustomDomain);
    }

    ngOnInit(): void {
        const tenantLicenseKey = this.isCustomDomainFeatureEnabled ? this._tenantData.tenantConfig?.pspdfkit_license?.pspdfkit : null;

        NutrientViewer.load({
            baseUrl: MaxBrainUtils.baseUrl + '/assets/',
            container: '#pspdfkit',
            document: this.pdf,
            licenseKey: tenantLicenseKey || this.environment.PSPDFKitLicenseKey,
            disableWebAssemblyStreaming: true,
            enableHistory: this.enableHistory,
        })
            .then((instance: Instance) => {
                instance.setViewState(instance.viewState.set('zoom', 'FIT_TO_WIDTH'));

                if (this.enableHistory) {
                    instance.setToolbarItems((items) => {
                        const insertionIndex = Math.max(items.length - 1, 0);

                        items.splice(insertionIndex, 0, { type: 'undo' }, { type: 'redo' });

                        return items;
                    });
                }

                this.load.emit(instance);
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
}
